import React from 'react';
import Icon from '@/components/AppIcon';

const ReviewStep = ({ formData, resumeFile }) => {
const formatSalaryRange = (min, max) => {
if (!min || !max) return 'Not specified';
if (max >= 999999) return `$${min?.toLocaleString()}+`;
return `$${min?.toLocaleString()} - $${max?.toLocaleString()}`;
};

const getWorkPreferenceLabel = (value) => {
const options = {
'remote': 'Remote Only',
'onsite': 'On-site Only',
'hybrid': 'Hybrid (Remote + On-site)',
'flexible': 'Flexible / No Preference'
};
return options?.[value] || value;
};

const getIndustryLabel = (value) => {
const industries = {
'technology': 'Technology & Software',
'finance': 'Finance & Banking',
'healthcare': 'Healthcare & Medical',
'education': 'Education & Training',
'marketing': 'Marketing & Advertising',
'sales': 'Sales & Business Development',
'engineering': 'Engineering & Manufacturing',
'consulting': 'Consulting & Strategy',
'retail': 'Retail & E-commerce',
'hospitality': 'Hospitality & Tourism'
};
return industries?.[value] || value;
};

const getCountryLabel = (value) => {
const countries = {
'us': 'United States',
'uk': 'United Kingdom',
'ca': 'Canada',
'au': 'Australia',
'de': 'Germany',
'fr': 'France',
'nl': 'Netherlands',
'sg': 'Singapore',
'ae': 'United Arab Emirates',
'in': 'India'
};
return countries?.[value] || value;
};

return (
<div className="space-y-6">
<div className="text-center mb-8">
<div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
<Icon name="ClipboardCheck" size={32} className="text-primary" />
</div>
<h2 className="text-2xl font-semibold text-foreground mb-2">
Review Your Information
</h2>
<p className="text-muted-foreground">
Please verify all details before proceeding
</p>
</div>
<div className="review-section">
<h3 className="review-section-title">Resume</h3>
<div className="review-item">
<span className="review-label">Uploaded File</span>
<span className="review-value font-mono">{resumeFile?.name || 'No file'}</span>
</div>
</div>
<div className="review-section">
<h3 className="review-section-title">Personal Information</h3>
<div className="review-item">
<span className="review-label">Gender</span>
<span className="review-value capitalize">{formData?.gender}</span>
</div>
<div className="review-item">
<span className="review-label capitalize">Date of birth</span>
<span className="review-value capitalize">{formData?.dob }</span>
</div>
<div className="review-item">
<span className="review-label">Location</span>
<span className="review-value capitalize">{formData?.city}, {getCountryLabel(formData?.country)}</span>
</div>

</div>
<div className="review-section">
<h3 className="review-section-title">Career Goals</h3>
<div className="review-item">
<span className="review-label">Industry</span>
<span className="review-value">{getIndustryLabel(formData?.industry)}</span>
</div>
<div className="review-item">
<span className="review-label">Salary Range</span>
<span className="review-value">{formatSalaryRange(formData?.salaryMin, formData?.salaryMax)}</span>
</div>
<div className="review-item">
<span className="review-label">Target Location</span>
<span className="review-value">
{Array.isArray(formData?.targetCountry) 
? formData?.targetCountry?.map(c => getCountryLabel(c))?.join(', ')
: getCountryLabel(formData?.targetCountry)}
</span>
</div>
<div className="review-item">
<span className="review-label">Work Preference</span>
<span className="review-value">{getWorkPreferenceLabel(formData?.workPreference)}</span>
</div>
</div>
<div className="review-section">
<h3 className="review-section-title">Target Job Roles</h3>
<div className="flex flex-wrap gap-2 mt-3">
{formData?.jobRoles?.map((role, index) => (
<span
key={index}
className="inline-flex items-center px-3 py-1.5 bg-primary/10 text-primary rounded-lg text-sm font-medium"
>
{role}
</span>
))}
</div>
</div>
<div className="p-4 bg-green-50 dark:bg-green-950/20 rounded-lg border border-green-200 dark:border-green-800">
<div className="flex items-start gap-3">
<Icon name="Shield" size={20} className="text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" />
<div className="text-sm text-green-900 dark:text-green-100">
<p className="font-medium mb-1">Your Data is Secure</p>
<p className="text-green-800 dark:text-green-200">
All information is encrypted and will only be used for automated job applications on your behalf.
</p>
</div>
</div>
</div>
</div>
);
};

export default ReviewStep;